import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { List, useDataGrid, DeleteButton } from "@refinedev/mui";
import React from "react";
import { FormControlLabel, Select } from "@mui/material";
import { useState } from "react";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { RemoveButton } from "components/buttons/remove";
import ReportedMessagesStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/reportedMessagesStatus";

export const ReportedMessagesList = () => {
    const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
      sorters: {
          initial: [
            {
              field: "updatedAt",
              order: "desc"
            }
          ]
      },
      pagination: {
        pageSize: 10,
      },
    });
    
    const columns = React.useMemo<GridColumns<any>>(
      () => [
        {
          field: "id",
          headerName: "Id",
          minWidth: 80,
          hideable: false,
        },
        {
          field: "messageId",
          headerName: "MessageId",
          minWidth: 80,
          hideable: false,
        },
        {
          field: "userId",
          headerName: "UserId",
          minWidth: 80,
          hideable: false,
        },
        {
          field: "roomId",
          headerName: "RoomId",
          minWidth: 80,
          hideable: false,
        },
        {
          field: "message",
          headerName: "Message",
          minWidth: 300,
          flex: 1,
          hideable: false,
        },
        {
          field: "userName",
          headerName: "userName",
          minWidth: 160,
          flex: 1,
          hideable: false,
        },
        {
          field: "roomName",
          headerName: "roomName",
          minWidth: 160,
          flex: 1,
          hideable: false,
        },
        {
          field: "count",
          headerName: "count",
          minWidth: 80,
          hideable: false,
        },
        {
          field: "status",
          headerName: "status",
          minWidth: 80,
          hideable: false,
          renderCell: function render({ row }) {
            return ReportedMessagesStatus.fromValue(row.status)?.name || "Unknown";
          },
        },
        {
          field: "updatedAt",
          headerName: "UpdatedAt",
          minWidth: 150,
          hideable: false,
          renderCell: function render({ row }) {
            if (row.updatedAt) {
              return new Date(row.updatedAt).toLocaleString();
            } else {
              return "";
            }
          },
        },
        {
          field: "actions",
          headerName: "Actions",
          hideable: false,
          sortable: false,
          renderCell: function render({ row }) {
            return (
              <>
                {row.status === 0 ? (
                  <RemoveButton hideText recordItemId={row.id} />
                ) : null}
                <DeleteButton hideText recordItemId={row.id} />
              </>
            );
          },
          align: "center",
          headerAlign: "center",
          minWidth: 80,
        },
      ],
      []
    );
    // search parts
    const [userName, setUserName] = useState("");
    const [roomName, setRoomName] = useState("");
    const [status, setStatus] = useState<any>("");
    const handleFilter = (
    ) => {
        setCurrent(1);
        setPageSize(10);
        let searchArr: {field: string; value: string; operator: string}[] = [];
        if (userName) {
            searchArr.push({
                field: "userName[$ilike]",
                value: `%${userName}%`,
                operator: "eq",
            });
        }
        if (roomName) {
            searchArr.push({
                field: "roomName[$ilike]",
                value: `%${roomName}%`,
                operator: "eq",
            });
        }
        if (status || status === 0) {
            searchArr.push({
                field: "status",
                value: `${status}`,
                operator: "eq",
            });
        } 
        setFilters(searchArr as any);
    };
    const clearFun = () => {
      setUserName("");
      setRoomName("");
      setStatus("");
    };
    return (
        <List>
            <FormControlLabel
                label=""
                style={{width: "100%"}}
                control={
                    <div style={{width: "100%"}}>
                        <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", paddingRight: "15px", marginBottom: "12px"}}>
                            <TextField id="standard-basic" label="UserName" variant="standard" value={userName} onChange={(e) => setUserName(e.target.value)} style={{width: "27%"}}/>
                            <TextField id="standard-basic" label="RoomName" variant="standard" value={roomName} onChange={(e) => setRoomName(e.target.value)} style={{width: "27%"}}/>
                            <FormControl style={{width: "27%"}}>
                                <InputLabel id="action">Status : </InputLabel>
                                <Select
                                    labelId="action"
                                    value={status as any}
                                    label="Status"
                                    variant="standard"
                                    onChange={(event: SelectChangeEvent) => {
                                        setStatus(event.target.value as any);
                                    }}
                                >
                                    {
                                        Object.values(ReportedMessagesStatus)[0].map((item: any) => {
                                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <div style={{width: "10%", paddingBottom: "7px"}}>
                                <ClearOutlinedIcon onClick={clearFun}/>
                                <SearchIcon onClick={handleFilter}/>
                            </div>
                        </div>
                    </div>
                }
            />
            <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
        </List>
    );
};